import { Action } from '@ngrx/store';
import {
    SESSION_INIT,
    SESSION_LOCALE_SET,
    SESSION_USER_FETCH,
    SESSION_USER_SET,
    SESSION_COMPANY_FETCH,
    SESSION_COMPANY_FEATURES_FETCH,
    SESSION_COMPANY_SET,
    SESSION_COMPANY_FEATURES_SET,
    SESSION_REDIRECT_STATE_SET,
    SESSION_COUNTRY_SET,
    SESSION_COUNTRY_FETCH,
    SESSION_SKILLSETS_SET,
    SESSION_SKILLSETS_FETCH,
    SESSION_CLEAR,
    USER_UPDATE,
    USER_PHONE_UPDATE,
    USER_EMAIL_UPDATE,
    SESSION_USER_PERMISSIONS_FETCH,
    SESSION_USER_PERMISSIONS_SET,
    SESSION_INIT_COMPLETE,
    SESSION_COMPANY_STATUS_SET
    
} from '../action-types';
import { ObservableAction } from '../shared/actions/observable-action';
import { UserUpdateRequest } from '@core/data/api/user/user-update-request';

export class InitSessionAction implements Action {
    readonly type = SESSION_INIT;

    constructor(public payload?: {
        isLogin?: boolean,
        bypassRedirection?: boolean
    }) {}
}

export class InitSessionCompleteAction implements Action {
    readonly type = SESSION_INIT_COMPLETE;

    constructor(public payload?: {
        isLogin?: boolean,
        bypassRedirection?: boolean,
        isOnboarding?: boolean
    }) {}
}

export class ClearSessionAction implements Action {
    readonly type = SESSION_CLEAR;
}

export class SetSessionLocaleAction implements Action {
    readonly type =  SESSION_LOCALE_SET;

    constructor(public payload:  { locale: string }) {}
}

export class FetchUserAction implements Action {
    readonly type = SESSION_USER_FETCH;
}

export class FetchUserPermissionsAction implements Action {
    readonly type = SESSION_USER_PERMISSIONS_FETCH;

    constructor(public payload: string) {}
}

export class SetUserPermissionsAction implements Action {
    readonly type = SESSION_USER_PERMISSIONS_SET;

    constructor(public payload: any) {}
}

export class SetUserAction implements Action {
    readonly type = SESSION_USER_SET;

    constructor(public payload: any) {}
}

export class FetchCompanyAction implements Action {
    readonly type = SESSION_COMPANY_FETCH;
}

export class FetchCompanyFeaturesAction implements Action {
    readonly type = SESSION_COMPANY_FEATURES_FETCH;
}

export class SetCompanyAction implements Action {
    readonly type = SESSION_COMPANY_SET;

    constructor(public payload: any) {}
}

export class SetCompanyFeaturesAction implements Action {
    readonly type = SESSION_COMPANY_FEATURES_SET;

    constructor(public payload: any) {}
}

export class SetRedirectStateAction implements Action {
    readonly type = SESSION_REDIRECT_STATE_SET;

    constructor(public payload: any) {}
}

export class FetchCountryAction implements Action {
    readonly type = SESSION_COUNTRY_FETCH;
}

export class SetCountryAction implements Action {
    readonly type = SESSION_COUNTRY_SET;

    constructor(public payload: any) {}
}

export class FetchSkillSetsAction implements Action {
    readonly type = SESSION_SKILLSETS_FETCH;
}

export class SetSkillSetsAction implements Action {
    readonly type = SESSION_SKILLSETS_SET;

    constructor(public payload: any) {}
}

export class SetCompanyStatusAction implements Action {
    readonly type = SESSION_COMPANY_STATUS_SET;

    constructor(public payload: any) {}
}

@ObservableAction()
export class UpdateUserAction implements Action {
    readonly type = USER_UPDATE;

    constructor(public payload: { id: string; request: UserUpdateRequest }) {}
}

@ObservableAction()
export class UpdateUserPhoneAction implements Action {
    readonly type = USER_PHONE_UPDATE;

    constructor(public payload: { id: string; phone: string; pin: string }) {}
}

@ObservableAction()
export class UpdateUserEmailAction implements Action {
    readonly type = USER_EMAIL_UPDATE;

    constructor(public payload: { id: string; email: string; pin: string }) {}
}

